import { render, staticRenderFns } from "./WipSearchResultsPage.vue?vue&type=template&id=3958bdf0&scoped=true&"
import script from "./WipSearchResultsPage.vue?vue&type=script&lang=ts&"
export * from "./WipSearchResultsPage.vue?vue&type=script&lang=ts&"
import style0 from "./WipSearchResultsPage.vue?vue&type=style&index=0&id=3958bdf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3958bdf0",
  null
  
)

export default component.exports